export default {
	"Wx.PleaseClickInTheUpperRightCornerToShare": "Please click [...] in the upper right corner to share"
}